/**
 * Interop shim for pdfjs-dist@2.16.105's ES5 legacy build.
 *
 * react-pdf@4.2.0 was written for the old pdfjs-dist 2.0.x UMD bundle and reads
 * the module's `.default` export (`_interopRequireDefault(require("pdfjs-dist"))
 * .default.GlobalWorkerOptions`). pdfjs-dist 2.16.105's build is compiled as an
 * ES module: it sets `__esModule = true` and exposes only NAMED exports
 * (GlobalWorkerOptions, getDocument, ...) with no `default`. Because
 * `__esModule` is truthy, `_interopRequireDefault` returns the namespace as-is
 * and `.default` is `undefined` -> "Cannot read properties of undefined
 * (reading 'GlobalWorkerOptions')" at runtime.
 *
 * config-overrides.js aliases the bare `pdfjs-dist` specifier to this file. We
 * load the legacy ES5 build and expose its namespace as `default` too, so both
 * `require("pdfjs-dist").default` and named access keep working.
 */
var pdfjs = require('pdfjs-dist/legacy/build/pdf.js');
if (pdfjs.default === undefined) {
  pdfjs.default = pdfjs;
}
module.exports = pdfjs;